export default {

  headline: 'Медиа-центр SIEGENIA ',
  search_info: 'Что вы ищете?',
  back: 'назад',
  service: {
    downloads: 'Документы',
    videos: 'Видео',
    faq: 'FAQ'
  },
  service_search: {
    category_placeholder: "Фильтр по категориям"
  },
  service_download: {
    select_info: 'Пожалуйста выберите область поиска',
    select_productgroup: 'Выберите продуктовую группу',
    select_product: 'Выберите продукт',
    select_type: 'Выберите формат файла',
    option_language: "язык",
    types: {
      tec_info: 'Техническая информация',
      installation: 'Монтажное руководство',
      planning: 'Документация для проектирования',
      catalog: 'Брошюры',
      order_forms: 'Формуляр для заказа',
      maintenance: 'Техническое и сервисное обслуживание и уход',
      construction_drawings: 'Чертежи',
      software: 'Программное обеспечение',
      certificate: 'Сертификаты и руководства',
      press: 'Матеиалы для прессы & маркетинговые документы',
      videos: 'Видео',
      undefined: 'Иное',
      commercial: 'Рекламные видео',
      product_video: 'Видео о продукте',
      operating: 'Управление продуктом',
      'function': 'Функционирование',
      'assembly': 'Сборка',
      'installation_video': 'Установка / Монтаж',
      'assembly_instructions': 'Pуководство по монтажу',
      'brochure': 'Брошюра',
      'tec_catalog': 'Технические каталоги',
      'tec_sheet': 'Технические характеристики',
      'usage_charts': 'Прикладные диаграммы',
      'profile_sheet': 'Листы данных профиля',
      'operations_manual': 'Инструкции по эксплуатации и техническому обслуживанию',
      hardware_info: 'Соответствующая информация',
      'installation_suggestion' : 'Предложение по установке',
      'general' : 'В целом',
      'troubleshooting' : 'исправление проблем',
      "smarthome:general" : 'В целом',
      'smarthome:installation' : 'установка',
      'smarthome:troubleshooting' : 'исправление проблем',
      'smarthome:startup' : 'Установка',
      'smarthome:operating' : 'служба',
      'order' : 'Заказ',
    },
    filter_sorting: {
      filter: "Фильтр",
      sorting: "Сортировать",
      asc: "Повышение титула (A-Z)",
      desc: "Снижение титула (Z-A)",
      date_asc: "Дата первый старейший",
      date_desc: "Дата первый",
      relevance: "По соотвествию",
      facet_headline: "Фильтровать результаты поиска",
      facet_filter_lang: "языки",
      facet_filter_level_0: "категория",
      facet_filter_type_id: "Тип документа",
      filter_remove: "Сбросной фильтр",
      show_hide: "Показать фильтры",

    },
    result: {
      count_media: "Формат документа",
      show_results: "Показать результаты",
      preview_type_catalog: "HTML",
      lang_not_available: "В настоящий момент не представлено файлов в выбранном языке",
      version_info: "Эта ссылка ведет на последнюю версию документации. Если вам нужна более старая версия, обратитесь к консультанту по работе с клиентами SIEGENIA."
    }
  }

};
